<ng-container *transloco="let t; read: 'register'">
	<form-wrapper [header]="t('title')" *ngIf="!processingRequest; else loading">
		<form [formGroup]="registerForm" (ngSubmit)="stepNum == 2 ? register() : nextStep()">
			<div *ngIf="stepNum==0">
				<div class="app-text__label-l">{{t('labelEmail')}}</div>
				<input type="text" formControlName="email" appAutofocus>
				<val-error controlNameToValidate="email">{{t('validationEmail')}}</val-error>
				<app-checkbox class="mti-4" formControlName="agreeToTermsAndConditions">
					{{t('labelAgreeToTermsAndConditions')}}
          <a [href]="t('labelOfferUrl')" target="_blank">{{t('labelOffer')}}</a>,
          <a [href]="t('labelAgreementUrl')" target="_blank">{{t('labelAgreement')}}</a> {{t('and')}}
          <a [href]="t('labelPrivacyUrl')" target="_blank">{{t('labelPrivacy')}}</a>
				</app-checkbox>
				<val-error controlNameToValidate="agreeToTermsAndConditions" align="left">{{t('validationAgreement')}}</val-error>
				<app-button class="mti-5" [disabled]="!stepValid" (click)="nextStep()">
					{{'buttons.next' | transloco}}
				</app-button>
			</div>
			<div *ngIf="stepNum==1">
				<div class="app-text__label-l">{{t('labelFirstName')}}</div>
				<input type="text" formControlName="firstName" appAutofocus>
				<val-error controlNameToValidate="firstName">{{t('validationFirstName')}}</val-error>
				<div class="mti-5 app-text__label-l">{{t('labelLastName')}}</div>
				<input type="text" formControlName="lastName">
				<val-error controlNameToValidate="lastName">{{t('validationLastName')}}</val-error>
				<app-button class="mti-5" [disabled]="!stepValid" (click)="nextStep()">
					{{'buttons.next' | transloco}}
				</app-button>
			</div>
			<div *ngIf="stepNum==2">
				<div class="app-text__label-l">{{t('labelPassword')}}</div>
				<input type="password" formControlName="password" #passwordInput appAutofocus>
				<val-error controlNameToValidate="password">{{t('validationPassword')}}</val-error>
				<app-button class="mti-5" [disabled]="registerForm.invalid" (click)="register()">
					{{'buttons.register' | transloco}}
				</app-button>
			</div>
		</form>
		<div *ngIf="stepNum==0">
			<div class="app-text__h3 mti-20 mbi-5">{{t('externalAccount')}}</div>
			<app-external-login></app-external-login>
			<div class="app-text__h3 mti-20 mbi-5">{{t('haveAccount')}}</div>
			<app-button appearance="outline" size="s" routerLink="/login" queryParamsHandling="merge">
				{{'buttons.login' | transloco}}
			</app-button>
		</div>
	</form-wrapper>
</ng-container>

<ng-template #loading>
	<div class="flex flex-jc-center mti-19">
		<app-loader [loading]="true">
		</app-loader>
	</div>
</ng-template>
